import { defineStore } from 'pinia'
import { ref } from 'vue'

import api from '@app/insights/api'

interface User {
  id: number
  name: string
  [key: string]: unknown
}

export const useUsersStore = defineStore('insights-users', () => {
  const users = ref<User[] | null>(null)

  async function fetchUsersForFirm(): Promise<void> {
    const data = (await api.fetchUsers()) as { users: User[] }
    users.value = data.users
  }

  function getUserById(id: number): User | undefined {
    return users.value?.find((user) => user.id === id)
  }

  return {
    users,
    fetchUsersForFirm,
    getUserById,
  }
})
